import { useStateContext } from "../../context/ContextProvider";
import { cn } from "../../lib/utils";
import { ResponsiveVideoPlayer } from "../Charities/layout";
import SecondaryButton from "../layout/SecondaryButton";
import {IoIosArrowBack,IoIosArrowForward} from "../icons"
export const C_BentoGrid = ({
  className,
  children
}) => {
  const {currentLang} =useStateContext()
  const HightSize ="md:auto-rows-[12rem]"
  return (
    <div
      className={cn(
        "mx-auto grid max-w-7xl grid-cols-1 gap-4 currentLang  md:grid-cols-2",
        className,HightSize
      )}>
      {children}
    </div>
  );
};

export const C_BentoGridItem = ({
  className,
  title,
  description,
  image,
  subtitle,
  id,
  video,
  onClick
}) => {


    const Style = "bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2 border border-light-glassStrock2  dark:border-dark-glassStrock1 ";
    const {currentLang,currentMode}=useStateContext()
    const isAr =currentLang==="ar"
  return (
    <div
      className={cn(
        "group/bento shadow-input row-span-1 flex flex-col justify-between space-y-4 rounded-xl  backdrop-blur-xl p-4 transition duration-200 hover:shadow-xl dark:border-white/[0.2] dark:shadow-none min-h-40",
        className,
        Style
      )}>
      

      {id === 1  ? (<div className="flex flex-col h-full  justify-between"> 
          <div className="transition   flex flex-col md:flex-row h-full gap-4 duration-200 group-hover/bento:translate-x-2">
         
         <div className="flex flex-col py-4 md:w-4/5">
           <div className="mb-4">
             <h4 className="h5 mb-1 text-light-link dark:text-dark-title">
               {title}
             </h4>
             {subtitle && (
               <h6 className="h6 text-light-subtitle dark:text-dark-subtitle mt-1">
                 {subtitle}
               </h6>
             )}
                <div className={`border border-b-1 ${isAr ? "mt-2" :""} border-light-strock`}></div>
           </div>
           <div className={`body-2 max-h-60 overflow-auto   text-neutral-600 dark:text-neutral-300 flex-grow`}>
             {description}
           </div>
          
           
         </div>
         <div className="md:w-1/5 w-full flex items-center justify-center  md:h-full rounded-lg overflow-hidden">
           <img src={image} className="max-h-[15rem]  object-contain w-full rounded-lg" alt={title} />
         </div>
        
       </div><div className="max-w-30">
       <SecondaryButton textSize={"text-sm font-kufi"} className={"px-[1rem] py-[0.5rem] rounded-lg"}  text={"Reade more"} icon={isAr   ? <IoIosArrowBack size={20}/>: <IoIosArrowForward size={20} />} onClick={onClick} />
        </div> </div>
   
      ) : id ===5 ?(
        <div className="flex flex-col h-full   justify-between ">  
        <div className="transition flex flex-col  h-full gap-4 duration-200 group-hover/bento:translate-x-2">
        
      
        <div className="flex flex-col">
          <div className="">
            <h4 className="h5 text-light-link dark:text-dark-title">
              {title}
            </h4>
           
          </div>
          <div className="border border-b-1 my-2 border-light-strock"></div>
          <div className="body-2 max-h-60 overflow-auto text-neutral-600 dark:text-neutral-300 flex-grow">
            {description}
          </div>
        </div>
      </div><div className="max-w-30 mt-4 ">
       <SecondaryButton textSize={"text-sm font-kufi"} className={"px-[1rem] py-[0.5rem] rounded-lg"}  text={"Reade more"} icon={isAr   ? <IoIosArrowBack size={20}/>: <IoIosArrowForward size={20} />} onClick={onClick} />
        </div> </div>
      ): id=== 4 ? (
        <div className="transition flex flex-col md:flex-row h-full gap-2 duration-200 group-hover/bento:translate-x-2">
        <div className=" w-full h-48 md:h-full rounded-lg overflow-hidden">
        <ResponsiveVideoPlayer link={video}/>
        </div>
     
      </div>
      ):(
        <div className="flex flex-col ">  
        <div className="transition flex flex-col md:flex-row h-full gap-2 duration-200 group-hover/bento:translate-x-2">
          
          <div className="flex flex-col ">
            <div className="mb-4">
              <h4 className="h5 text-light-link dark:text-dark-title">
                {title}
              </h4>
             
            </div>
            <div className="body-2 max-h-16 overflow-auto text-light-subtitle dark:text-dark-subtitle  flex-grow">
              {description}
            </div>
            
            
          </div>
        </div><div className="max-w-30 mt-2">
       <SecondaryButton textSize={"text-sm font-kufi"} className={"px-[1rem] py-[0.5rem] rounded-lg"} text={"Reade more"} icon={isAr   ? <IoIosArrowBack size={20}/>: <IoIosArrowForward size={20} />} onClick={onClick} />
        </div> </div>
      )}
    </div>
  );
};